<template>
  <v-badge
      :value=hover
      class="hover-badge"
      color="blue-grey"
      :content="item.week_start_format"
      offset-y="10px"
      offset-x="-5px"
      right
      overlap
      transition="fade-transition"
  >
    <v-hover v-model="hover">
      <router-link :to="{name:'BatchRunHistoryList_BatchRunHistoryItem', params: { itemId: item.id}}">{{
          item.year_week
        }}
      </router-link>
    </v-hover>
  </v-badge>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {mapFields} from "vuex-map-fields";

export default {
  name: 'BatchRunYearWeekLink',
  props: ['item'],

  data() {
    return {
      hover: false,
      hoverFlag: false,
    }
  },

  components: {},

  computed: {
    ...mapFields('BatchRunWeek', ['active_batch_run', 'smd_start_plan', 'smd_end_plan',
      'tht_start_plan', 'tht_end_plan', 'smd_end', 'tht_end', 'lt_mat', 'lt_min']),
  },

  methods: {
    onClickBadge(event) {
      console.log('Click badge', this.item)
      this.active_batch_run = this.item
      this.smd_start_plan = this.item.smd_start_plan
      this.smd_end_plan = this.item.smd_end_plan
      this.tht_start_plan = this.item.tht_start_plan
      this.tht_end_plan = this.item.tht_end_plan
      this.smd_end = this.item.smd_end
      this.tht_end = this.item.tht_end
      this.lt_mat = this.item.lt_mat
      this.lt_min = this.item.lt_min
      event.stopPropagation()
    },
    onStartDrag(event) {
      // console.log('onStartDrag', event, this.item.id)
      event.dataTransfer.setData('itemID', this.item.id)
      this.active_batch_run = null
      this.smd_start_plan = null
      this.smd_end_plan = null
      this.tht_start_plan = null
      this.tht_end_plan = null
      this.smd_end = null
      this.tht_end = null
      this.lt_mat = null
      this.lt_min = null
    },
    getBadgeSMDColor() {
      // console.log('getBadgeSMDColor', this.item.title, this.item.smd, this.item.smd_end)
      if (this.item.smd > 0) {
        if (this.item.smd_end)
          return 'smd_light_color'
        else
          return 'smd_color'
      }
      return 'grey lighten-1'
    },
    getBadgeTHTColor() {
      // console.log('getBadgeTHTColor', this.item.title, this.item.smd, this.item.smd_end)
      if (this.item.tht > 0) {
        if (this.item.tht_end)
          return 'tht_light_color'
        else
          return 'tht_color'
      }
      return 'grey lighten-1'
    },
    getBadgeTextColorClass() {
      return 'black-text'
    },
  },

  mounted() {
  },
}
</script>

<style scoped lang="scss">
.drag-el {
  //background-color: #fff;
  //margin-bottom: 10px;
  //padding: 10px;
}

.hover-badge {
  z-index: 1;
}

.black-text {
  color: black;
}

.white-text {
  color: white;
}

* {
  //font-weight: bold;
}
</style>